import React, { Component } from "react";
import { connect } from "react-redux";

import { addToBucket, removeFromBucket } from "../actions/siteActions";

import { translate } from "../functions";
import Badge from "./Badge";
import DownloadableContent from "./DownloadableContent";
import { BrowserView, MobileView } from "react-device-detect";

import { formatText } from "../utils/functions";

class Product extends Component {
  isInBucket = (product) => {
    if (this.props.site.bucket[product.id]) {
      this.props.removeFromBucket(product.id);
    } else {
      this.props.addToBucket(product);
    }
  };

  render() {
    const { site, product } = this.props;
    let imageUrl = "";
    if (product && product.acf && product.acf.image && product.acf.image.url) {
      imageUrl = product.acf.image.url;
      imageUrl = product.acf.image.sizes["medium"];
    }

    return (
      <div className="product ">
        <div className="image" style={{ backgroundImage: `url(${imageUrl})` }}>
          {product && product.acf && product.acf.badge && (
            <Badge badgeValue={product.acf.badge} />
          )}

          <MobileView>
            <div className="clickable" onClick={() => this.isInBucket(product)}>
              Vali
              <div
                className={`checkBox ${
                  product.id in site.bucket ? "checked" : ""
                }`}
              >
                {product.id in site.bucket ? "✔" : ""}
              </div>
            </div>
          </MobileView>
        </div>
        <div className="content">
          <h3>{product.title.rendered}</h3>
          <BrowserView>
            <table
              cellSpacing="2"
              cellPadding="0"
              border="0"
              width="100%"
              className="info"
            >
              <thead>
                <tr>
                  {Object.keys(product.acf.info).map((info, i) => (
                    <th
                      key={i}
                      style={{
                        backgroundColor: site.current.category.acf.varvus,
                      }}
                    >
                      <span>{translate(info)}</span>
                    </th>
                  ))}
                  <th
                    style={{
                      backgroundColor: site.current.category.acf.varvus,
                    }}
                  >
                    VALI
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  {Object.keys(product.acf.info).map((info, i) => (
                    <td key={i}>
                      <span>{product.acf.info[info]}</span>
                    </td>
                  ))}
                  <td
                    className="clickable"
                    onClick={() => this.isInBucket(product)}
                  >
                    <div
                      className={`checkBox ${
                        product.id in site.bucket ? "checked" : ""
                      }`}
                    >
                      {product.id in site.bucket ? "✔" : ""}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            {product &&
              product.acf &&
              (product.acf.tootekaart || product.acf.image) && (
                <React.Fragment>
                  <span className="downloadIcon" style={{   position
                      :"realative",display:"flex",justifyContent:"center",alignItems:"center",
                    backgroundColor: site.current.category.acf.varvus,
                  }}>
                </span>
             
                  <DownloadableContent acf={product.acf} />
                </React.Fragment>
              )}
          </BrowserView>
          <MobileView>
            {Object.keys(product.acf.info).map((info, i) => (
              <div className="infoRow" key={i}>
                <div
                  className="infoTitle"
                  style={{
                    backgroundColor: site.current.category.acf.varvus,
                  }}
                >
                  {translate(info)}
                </div>{" "}
                <div className="infoValue" key={i}>
                  {product.acf.info[info]}
                </div>
              </div>
            ))}
            <DownloadableContent acf={product.acf} />
          </MobileView>{" "}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  site: state.site,
});

export default connect(mapStateToProps, { addToBucket, removeFromBucket })(
  Product,
);
